'use strict'

angular
  .module('basalteApp')
  .constant('BAS_CAMERAS', {
    EVT_CAMERAS_UPDATED: 'evtCamerasUpdated'
  })
